import dayjs from "dayjs";
import TableActionMenu from "./TableActions/TableActionMenu";
import { Box, Typography } from "@mui/material";

export const generateShippingServiceColumns = (actions, user) => {
  const arr = [
    {
      name: "Created On",
      grow: 2,
      selector: (row) => row?.createdAt,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {dayjs(row.createdAt).format('DD/MM/YYYY')}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Warehouse",
      grow: 2,
      selector: (row) => row?.wareHouseDetails?.warehouseName || "",
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row?.wareHouseDetails?.warehouseName || ""}
          </Typography>
        );
      },
      // sortable: true,
    },
    {
      name: "Routing Type",
      grow: 2,
      selector: (row) => row.routeType,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.routeType}
          </Typography>
        );
      },
      // sortable: true,
    },
    {
      name: "To",
      grow: 2,
      selector: (row) => row?.toCountry,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.toCountry}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "From",
      grow: 2,
      selector: (row) => row?.fromCountry,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.fromCountry}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Available Weight(Pounds)",
      grow: 2,
      selector: (row) => row?.minimumWeight,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.minimumWeight}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Bookings",
      grow: 2,
      selector: (row) => row?.bookings,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.bookings}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Carrier",
      grow: 2,
      selector: (row) => row?.carrierPartner?.carrierPartnerName || "",
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row?.carrierPartner?.carrierPartnerName || ""}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      //   cell: (row) => (row.isCarrierPartner ? "Yes" : "No"),
      cell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              paddingX: "8px",
              paddingY: "4px",
              backgroundColor:
                row.status === "In Progress" ? "#F2994A" : "#2DC58C",
              borderRadius: "2px",
              color: "white",
              whiteSpace: "nowrap",
            }}
          >
            {row.status}
          </Typography>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => {
        // console.log(actions, "actions>>>");
        // console.log(row, "row>>>");
        const updatedActionList = actions.filter((act) => {
          if (act.id === "add-main-address") {
            if (row.isRoutePartner) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });
        // console.log(updatedActionList, "updatedActionList>>>");
        return (
          <TableActionMenu row={row} updatedActionList={updatedActionList} />
        );
      },
      sortable: false,
      // hide: "md",
    },
  ];
  //   return user?.role === "Superadmin" || user?.role === "Platform Admin"
  //     ? arr
  //     : arr.filter((a) => a.name !== "action");

  // return arr.filter((a) => a.name !== "action");
  return arr;
};
